import isEmpty from "lodash/isEmpty";
import { PARAMETER_OPTIONS, PARAMETER_OPTIONS_ARRAY } from "../constants";
const { FREEFORM } = PARAMETER_OPTIONS;

const cleanAndSortParameters = (parameters) => {
  return PARAMETER_OPTIONS_ARRAY.filter((elem) => parameters.includes(elem));
};

const otherExerciseProperties = async (
  body,
  files,
  api,
  user,
  exercise = null
) => {
  const {
    parameter0,
    parameter1,
    parameter2,
    parameter3,
    exerciseTypeField,
    primaryMuscleGroup,
    secondaryMuscleGroup,
    instructions,
    videoUrl,
    videoDeleteOtherExercise,
  } = body;

  const parameters = cleanAndSortParameters([
    parameter0,
    parameter1,
    parameter2,
    parameter3,
  ]);

  let videoData;
  if (!videoUrl && !isEmpty(files)) {
    videoData = await (
      await api("other-exercise-video", {
        method: "POST",
        body: { userId: user._id, userEmail: user.email },
        files,
      })
    ).json();
  } else if (videoUrl || (exercise && exercise.video && exercise.video.url)) {
    videoData = {
      url: videoUrl || (exercise.video && exercise.video.url),
    };
  }

  return {
    parameters: parameters[0] === FREEFORM ? [parameters[0]] : parameters,
    video:
      videoData ||
      (videoDeleteOtherExercise ? "" : (exercise && exercise.video) || ""), // video empty it means deleted
    exerciseTypeField: exerciseTypeField === "None" ? "" : exerciseTypeField,
    primaryMuscleGroup: primaryMuscleGroup === "None" ? "" : primaryMuscleGroup,
    secondaryMuscleGroup:
      secondaryMuscleGroup === "None" ? "" : secondaryMuscleGroup,
    instructions: instructions ? instructions.trim() : "",
  };
};

const ExerciseCatalog = (app) => {
  app
    .post(
      "/exercise-catalog/save/:id?",
      async ({ api, assert, flash, load, locals, req, res }) => {
        const { body, files, params } = req;

        assert(body.movement, 400, "Exercise name is required.");
        assert(body.primary, 400, "Primary of the exercise is required.");

        await load("exerciseCatalog", { primary: body.primary });
        const { activeUser, exerciseCatalog } = locals;

        const exists = exerciseCatalog.find(({ _id, movement, primary }) =>
          movement.toLowerCase() === body.movement.trim().toLowerCase() &&
          primary === body.primary &&
          params.id
            ? params.id !== _id
            : false
        );

        assert(!exists, 400, "An exercise with this name already exists.");

        const exercise = params.id
          ? exerciseCatalog.find(({ _id }) => _id === params.id)
          : null;
        const otherExtraProperties = await otherExerciseProperties(
          body,
          files,
          api,
          activeUser,
          exercise
        );

        const submitBody = Object.assign(
          {
            movement: body.movement.trim(),
            primary: body.primary,
          },
          otherExtraProperties
        );

        if (params.id) {
          await api(`exercise-catalog/${params.id}`, {
            method: "PUT",
            body: submitBody,
          });
        } else {
          await api("exercise-catalog", {
            method: "POST",
            body: submitBody,
          });
        }

        flash("success", "Successfully saved");

        res.refreshWith(
          { modal: "", exercise: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .get(
      "/exercise-catalog/delete/:id",
      async ({ api, assert, flash, req, res }) => {
        // if (
        //   process.browser &&
        //   !confirm("Are you sure you want to delete this exercise?")
        // ) {
        //   return res.backDontScroll();
        // }

        const { id } = req.params;
        assert(id, 400, "Please provide the ID of the exercise to delete.");

        await api(`exercise-catalog/${id}`, {
          method: "DELETE",
        });

        flash("success", "Successfully deleted");
        res.backDontScroll();
      }
    );
};

export default ExerciseCatalog;
